/* unplugin-vue-components disabled */import script from "./UploadSinglePicture.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadSinglePicture.vue?vue&type=script&setup=true&lang=js"

import "./UploadSinglePicture.vue?vue&type=style&index=0&id=1f128d1f&lang=scss&scoped=true"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f128d1f"]])

export default __exports__